/* External */
import { memo } from 'react';

/* Ott-common */
import { usePlayerTime, usePlayerDuration } from '@dtvgo/player-context';

/* Components */
import RemainingTime from './RemainingTime';

function VodRemainingTime() {
  return <RemainingTime progress={usePlayerTime()} duration={usePlayerDuration()} />;
}

export default memo(VodRemainingTime);
